import { motion } from 'framer-motion';
import { sectionVariants } from './settings.animations';
import styles from '../Settings.module.css';

export interface AccountSectionProps {
  email: string | null | undefined;
  isSigningOut: boolean;
  onSignOutClick: () => void;
}

export function AccountSection({ email, isSigningOut, onSignOutClick }: AccountSectionProps) {
  return (
    <motion.section
      className={styles.section}
      variants={sectionVariants}
      aria-labelledby="account-heading"
    >
      <div className={styles.sectionHeader}>
        <span className={styles.sectionIcon} aria-hidden="true">
          @
        </span>
        <h2 id="account-heading" className={styles.sectionTitle}>
          Account
        </h2>
      </div>

      <div className={styles.accountInfo}>
        <div className={styles.accountEmail}>
          <span className={styles.emailIcon} aria-hidden="true">
            [=]
          </span>
          <span className={styles.emailText}>{email ?? 'Not logged in'}</span>
          <span className={styles.emailLabel}>Email</span>
        </div>

        <div className={styles.accountActions}>
          <motion.button
            type="button"
            className={`${styles.btn} ${styles.btnDanger}`}
            onClick={onSignOutClick}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            disabled={isSigningOut}
          >
            {isSigningOut ? 'Signing out...' : 'Sign Out'}
          </motion.button>
        </div>
      </div>
    </motion.section>
  );
}
